import React, {useEffect} from 'react';
import RegistrationContent from "./registration-content.jsx";
import ActionsContent from "./actions-content.jsx";
import AssumedByAgentsContent from "./assumed-by-agents-content.jsx";
import MapContent from "./map/map-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";
import ProjectUtils from "../../../../../utils/project-utils.js";

const ReportContent = ({ data, collapsed, showMap, mapImage, mapMode, setMapMode, setMapLoaded }) => {
    useEffect(() => {
        const createActionsExportTable = (actionsData, title) => {
            const labels = [];
            const values = [];

            actionsData.forEach((element) => {
                labels.push(translate(element.label ?? element.text));
                values.push(element.qty ?? 0);
            });

            ReportUtils.createExportableTable(labels, values, title, null, ["Ação", "Quantidade"]);
        };

        const formatDateTime = (value) => {
            const date = ProjectUtils.toDate(value);
            return date ? ProjectUtils.formatDate(date) : "Não informado";
        };

        const registrationActions = (data?.actionsDistribution?.activation_actions ?? []).flatMap(item => item.actions ?? []);
        const inactivationActions = (data?.actionsDistribution?.inactivation_actions ?? []).flatMap(item => item.actions ?? []);
        const maintenanceActions = (data?.actionsDistribution?.maintence_actions ?? []).flatMap(item => item.actions ?? []);
        const assumedByAgents = (data?.apply?.user_analisys ?? []).flatMap(item => item.details ?? []);
        const locationDetails = (data?.apply?.locations ?? []).flatMap(item => item.details ?? []);

        const registrationLabels = [];
        const registrationValues = [];

        registrationActions.forEach((element) => {
            registrationLabels.push(translate(element.label ?? element.text));
            registrationValues.push(element.qty);
        });

        const assumedByAgentsValues = assumedByAgents
            .map(item => ([
                item.agent,
                item.total_qty,
                item.cpf_qty,
                item.cnpj_qty,
                item.avg_ack_time,
            ]));

        const locationValues = locationDetails
            .filter(item => !Number.isNaN(Number(item.latitude)) && !Number.isNaN(Number(item.longitude)))
            .map(item => ([
                item.latitude,
                item.longitude,
                item.info_window?.citizen ?? "Não informado",
                item.info_window?.agent ?? "Não informado",
                formatDateTime(item.info_window?.event_start),
                formatDateTime(item.info_window?.event_ack),
            ]));

        ReportUtils.createExportableTable(registrationLabels, registrationValues, "Cadastros");
        createActionsExportTable(inactivationActions, "Ações de inativação");
        createActionsExportTable(maintenanceActions, "Ações de acompanhamento");
        ReportUtils.createExportableTable(["Assumido por", "SOS assumidos", "Total CPF", "Total CNPJ", "Tempo médio para assumir"], assumedByAgentsValues, "SOS assumidos por agentes");
        ReportUtils.createExportableTable(["Latitude", "Longitude", "Acionado por", "Assumido por", "Acionado em", "Assumido em"], locationValues, "Distribuição geográfica");
    }, [data]);

    return (
        <>
            <MapContent key={`map-${collapsed}`} data={data} showMap={showMap} mapImage={mapImage} mapMode={mapMode} setMapMode={setMapMode} setMapLoaded={setMapLoaded}/>
            <AssumedByAgentsContent key={`assumed-${collapsed}`} data={data}/>
            <RegistrationContent key={`registration-${collapsed}`} data={data}/>
            <ActionsContent key={`inactivation-actions-${collapsed}`} data={(data?.actionsDistribution?.inactivation_actions ?? []).flatMap(item => item.actions ?? [])} elementId={'inactivation-actions'} elementLabels={'label'} title={"Ações de inativação"} translateLabels={true} top={10}/>
            <ActionsContent key={`maintenance-actions-${collapsed}`} data={(data?.actionsDistribution?.maintence_actions ?? []).flatMap(item => item.actions ?? [])} elementId={'maintenance-actions'} elementLabels={'label'} title={"Ações de acompanhamento"} translateLabels={true} top={10}/>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;